import { useDispatch } from "react-redux";
import {
  createSubscription,
  cancelSubscription,
  pauseSubscription,
  cancelSuspension,
  restartSubscription,
  changeSubscriptionPlan,
} from "@actions/user-actions";

export function useCreateSubscription() {
  const dispatch = useDispatch();

  return (newSubscription) => dispatch(createSubscription(newSubscription));
}

export function useCancelSubscription() {
  const dispatch = useDispatch();

  return (unsubscribingDetails) => dispatch(cancelSubscription(unsubscribingDetails));
}

export function usePauseSubscription() {
  const dispatch = useDispatch();

  return (unsubscribingDetails) => dispatch(pauseSubscription(unsubscribingDetails));
}

export function useCancelSuspension() {
  const dispatch = useDispatch();

  return () => dispatch(cancelSuspension());
}

export function useRestartSubscription() {
  const dispatch = useDispatch();

  return () => dispatch(restartSubscription());
}

export function useChangeSubscriptionPlan() {
  const dispatch = useDispatch();

  return () => dispatch(changeSubscriptionPlan());
}

